import { getMessage } from "../../../msgs/msgs"
import { STATUS } from "../../../utils/const"
import s from "./StatusInfo.module.css"

export const StatusInfo = ({
  status,
  value,
}: {
  status: STATUS
  value?: string
}) => {
  return (
    <div className={`${s.statusInfo} ${s?.[status]}`}>
      {value || getMessage(status)}
    </div>
  )
}
